import React, { useCallback, useContext, useEffect, useState, } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { PlayerUIContext, volumeOpen } from '@24i/player-ui';
import useDimensions from '@24i/nxg-sdk-quantum/src/Dimensions/hooks/useDimensions';
import { VolumeRocker } from './components/VolumeRocker';
import { VolumeButton } from '../../Volume/components/VolumeButton';
import { VolumeContainer } from './styled';
const SHOW_VOLUME_BREAKPOINT = 640;
export const PodcastVolume = ({ className = '', playerInstance, customIcon, disabled, styles = {
    container: null,
    button: {},
    rocker: {},
}, }) => {
    const { dispatch } = useContext(PlayerUIContext);
    const { viewPortWidth } = useDimensions();
    const [isGestureInProgress, setGestureInProgress] = useState(false);
    const [volume, setVolume] = useState(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.volume);
    const [muted, setMuted] = useState(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.muted);
    useEventListener('mutedchanged', (data) => {
        setMuted(data.muted);
    }, playerInstance);
    useEventListener('volumechange', (data) => {
        setVolume(data.volume);
    }, playerInstance);
    const show = useCallback(() => {
        if (!isGestureInProgress) {
            dispatch(volumeOpen());
        }
    }, [dispatch, isGestureInProgress]);
    useEffect(() => show(), [show]);
    if (viewPortWidth < SHOW_VOLUME_BREAKPOINT)
        return (React.createElement(VolumeButton, { playerInstance,
            show,
            hide: () => { },
            muted,
            volume,
            customIcon,
            disabled, styles: styles.button, variant: "podcast" }));
    return (React.createElement(VolumeContainer, { style: styles.container, onDoubleClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        }, "data-test": "Volume", className: `Volume ${className}` },
        React.createElement(VolumeButton, { playerInstance,
            show,
            hide: () => { },
            muted,
            volume,
            customIcon,
            disabled, styles: { button: { position: 'relative', left: -105 } }, variant: "podcast" }),
        React.createElement(VolumeRocker, { styles: styles.rocker.slider, "data-test": "VolumeRocker", playerInstance,
            setGestureInProgress,
            isGestureInProgress,
            muted,
            volume })));
};
//# sourceMappingURL=index.js.map